import { Card, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";

const AuditStructureForm = () =>{
    const facility_options=[{label:"test",value:"test"}]
    const leader_options=[{label:"test",value:"test"}]
    const esteem_audit_options=[{label:"test",value:"test"}]
    return(
        <>
        <Card className="mt-2 mb-2">
            <Card.Header>Структура аудита</Card.Header>
            <Card.Body>
                <Form>
                    <div className="planing_audit_block_first_row">
                        <div className="item_1">
                            <div className="mb-1">
                                <Form.Control type="text" placeholder="Название аудита..."/>
                                <Form.Text>предупреждение</Form.Text>
                            </div>
                            <div className="mb-1">
                                <Form.Control placeholder="Описание аудита..." as="textarea" rows={2} />
                            </div>
                            <div className="mb-1 planing_audit_block_second_row">
                                <div className="m-1 item_3">
                                <Form.Label>Активация:</Form.Label>
                                <Form.Select aria-label="Default select example">
                                    <option>По требованию</option>
                                    <option>По расписанию</option>
                                </Form.Select>
                            </div>
                            <div className="m-1 item_3">
                                <Form.Label>Доступ к результатам:</Form.Label>
                                <Form.Select aria-label="Default select example">
                                    <option>Результаты доступны</option>
                                    <option>Результаты не доступны</option>
                                </Form.Select>
                            </div>
                            </div>
                            <div className="mb-1 planing_audit_block_second_row">
                                <Select className="item m-1" placeholder="Самоаудит..." isClearable/>
                                <Select className="item m-1" placeholder="Завод..." isClearable/>
                                <Select className="item m-1" placeholder="Лидер аудита..." isClearable/>
                            </div>
                        </div>
                        <div className="item_2">
                            <div className="first_row">
                                <div className="m-1 item_first">
                                    <Form.Check label="Рассылка по email"/>
                                </div>
                                <div className="m-1 item_first">
                                    <Form.Select aria-label="Default select example">
                                        <option>Тип аудита...</option>
                                        <option>Обычный</option>
                                        <option>Самоаудит</option>
                                    </Form.Select>
                                </div>
                            </div>
                            
                            <div className="m-1">
                                <Form.Label>Дата начала:</Form.Label>
                                <Form.Control type="datetime-local"/>
                            </div>
                            <div className="m-1">
                                <Form.Label>Дата окончания:</Form.Label>
                                <Form.Control type="datetime-local"/>
                            </div>
                        </div>
                    </div>
                </Form>                
            </Card.Body>
        </Card>
        </>
    )
}

export default AuditStructureForm;